module.exports = __webpack_public_path__ + "static/media/comments.3f9a1398.svg";